export default "__VITE_ASSET__DqVZMU6O__"